
const storageJSERROR = 'pv-spa-csm-jserror'
const storageCOUNT = 'pv-spa-csm-count'
const additionalInfo = { 
  logLevel : 'ERROR',
  attribution : 'pv-windows-app',
  message : `[PVWinApp]`
};

class OfflineCSM {
  
  constructor() {
    if(typeof window !== 'undefined') {
      if(window.navigator.onLine) {
        this.executeQueue()
      }
      window.addEventListener('online', this.executeQueue)
    }
  }
  
  runQueue = (storageName: string, fn: any) => {
    const storage = localStorage.getItem(storageName)
    try {
      if(storage) {
        const items: Array<[string, number]|[object, string]> = JSON.parse(storage)
        let i = items.length
        while (i--) {
          // Execute CSM function
          if(typeof fn === 'function' && items[i]){
            fn(...items[i])
          }
          // Remove from Stack
          items.splice(i, 1)
        }
        // Save updated stack in localStorage
        localStorage.setItem(storageName, JSON.stringify(items))
      }
    } catch (e) {
      window.ueLogError(e, additionalInfo);
      console.error("Unable to runQueue()", e)
    }
  }
  
  executeQueue = () => {
    // when Online, we flush the queue of actions
    this.runQueue(storageCOUNT, count)
    this.runQueue(storageJSERROR, jsError)
  }
  
  saveOfflineJsError = (e: Object, message: string) => {
    this.saveLocalStorage([e, message], storageJSERROR)
  }
  
  saveOfflineCount = (scope: string, val: number) => {
    this.saveLocalStorage([scope, val], storageCOUNT)
  }
  
  saveLocalStorage = (item: Array<any>, storageName: string) => {
    const storage = localStorage.getItem(storageName)
    const items = storage ? JSON.parse(storage) : []
    items.push(item)
    localStorage.setItem(storageName, JSON.stringify(items))
  }
  
}

export const count = (scope: string, val: number = 1) => {
  if(typeof window !== 'undefined' && window.ue) {
    if(window.navigator.onLine) {
      window.ue.count(`PVWinApp-${scope}`, val);
    } else {
      csm.saveOfflineCount(`${scope}-offline`, val)
    }
  }
}

export const jsError = (e: Object, message: string) => {
  if (typeof window !== 'undefined' && window.ueLogError) {
    if(window.navigator.onLine) {
      window.ueLogError(e, Object.assign(additionalInfo, {
        message: `${additionalInfo.message} - ${message}`
      }));
    } else {
      csm.saveOfflineJsError(e, `${message} - OFFLINE`)
    }
  }
}

const csm = new OfflineCSM()
